import { Navigate, createFileRoute } from '@tanstack/react-router'

/**
 * Lifecycle folded into Storage's Retention tab (docs/storage-requirements.md
 * §Redirects). The route stays so the old rail link and any bookmark land
 * on the retention tab instead of a 404.
 */
function LifecycleRedirect() {
  const { clusterId, scopeId } = Route.useParams()
  return (
    <Navigate
      to="/$clusterId/$scopeId/fabric/storage"
      params={{ clusterId, scopeId }}
      search={{ tab: 'retention' }}
      replace
    />
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/fabric/lifecycle')({
  component: LifecycleRedirect,
})
